import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  activityFeed: {
    id: 'components.AppSideMenu.activityFeed',
    defaultMessage: 'Activity Feed',
  },
  schedule: {
    id: 'components.AppSideMenu.schedule',
    defaultMessage: 'Schedule',
  },
  hub: {
    id: 'components.AppSideMenu.hub',
    defaultMessage: 'Hub',
  },
  broadcast: {
    id: 'components.AppSideMenu.broadcasts',
    defaultMessage: 'Broadcasts',
  },
  inboundReferrals: {
    id: 'components.AppSideMenu.referrals',
    defaultMessage: 'Inbound Referrals',
  },
  outboundReferrals: {
    id: 'components.AppSideMenu.outboundReferrals',
    defaultMessage: 'Outbound Referrals',
  },
  outreach: {
    id: 'components.AppSideMenu.outreach',
    defaultMessage: 'Outreach',
  },
  waitlists: {
    id: 'components.AppSideMenu.waitlists',
    defaultMessage: 'Waitlists',
  },
  reports: {
    id: 'components.AppSideMenu.reports',
    defaultMessage: 'Reports',
  },
  patientBilling: {
    id: 'components.AppSideMenu.patientBilling',
    defaultMessage: 'LumaPay',
  },
  analyzer: {
    id: 'components.AppSideMenu.analyzer',
    defaultMessage: 'Analyzer',
  },
  recalls: {
    id: 'components.AppSideMenu.recalls',
    defaultMessage: 'Recalls',
  },
});
